module.exports = __webpack_public_path__ + "assets/favicons/404.svg";